import { Navigate, useLocation } from 'react-router'

import { EMPTY_STRING } from '../../../constants/common'

function RouteRemoveRedesignPrefix() {
  const { hash, pathname, search } = useLocation()

  const newPath = pathname.replace(/^\/redesign/, EMPTY_STRING) || '/'

  return <Navigate replace to={newPath + search + hash} />
}

export default RouteRemoveRedesignPrefix
